/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MilestoneResponse,
    MilestoneResponseFromJSON,
    MilestoneResponseFromJSONTyped,
    MilestoneResponseToJSON,
    OWLogCategory,
    OWLogCategoryFromJSON,
    OWLogCategoryFromJSONTyped,
    OWLogCategoryToJSON,
    OWRewardMaxType,
    OWRewardMaxTypeFromJSON,
    OWRewardMaxTypeFromJSONTyped,
    OWRewardMaxTypeToJSON,
    OWRewardMode,
    OWRewardModeFromJSON,
    OWRewardModeFromJSONTyped,
    OWRewardModeToJSON,
    QuestReset,
    QuestResetFromJSON,
    QuestResetFromJSONTyped,
    QuestResetToJSON,
    RewardConfigResponse,
    RewardConfigResponseFromJSON,
    RewardConfigResponseFromJSONTyped,
    RewardConfigResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface OWQuestResponse
 */
export interface OWQuestResponse {
    /**
     * 
     * @type {string}
     * @memberof OWQuestResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OWQuestResponse
     */
    game?: string;
    /**
     * The title of the reward.
     * @type {string}
     * @memberof OWQuestResponse
     */
    name: string;
    /**
     * The description of the reward.
     * @type {string}
     * @memberof OWQuestResponse
     */
    description?: string;
    /**
     * If the quest is active (shows on FE and tracks in the BE) or not.
     * @type {boolean}
     * @memberof OWQuestResponse
     */
    isActive: boolean;
    /**
     * If the quest complete notification should be shown.
     * @type {boolean}
     * @memberof OWQuestResponse
     */
    showQuestCompleteNotification?: boolean;
    /**
     * The message to show in the quest complete notification.
     * @type {string}
     * @memberof OWQuestResponse
     */
    questCompleteNotificationMessage?: string;
    /**
     * The maximum amount of reward that can be claimed.
     * @type {number}
     * @memberof OWQuestResponse
     */
    rewardMax?: number;
    /**
     * 
     * @type {OWRewardMaxType}
     * @memberof OWQuestResponse
     */
    rewardMaxType?: OWRewardMaxType;
    /**
     * 
     * @type {OWLogCategory}
     * @memberof OWQuestResponse
     */
    rewardCategory: OWLogCategory;
    /**
     * 
     * @type {string}
     * @memberof OWQuestResponse
     */
    eventType: string;
    /**
     * The target amount of progress to reach to claim the reward.
     * @type {number}
     * @memberof OWQuestResponse
     */
    target: number;
    /**
     * 
     * @type {QuestReset}
     * @memberof OWQuestResponse
     */
    questReset?: QuestReset;
    /**
     * 
     * @type {Array<MilestoneResponse>}
     * @memberof OWQuestResponse
     */
    milestones?: Array<MilestoneResponse>;
    /**
     * If the quest is available for all supported games that are not in our database (OWGames).
     * @type {boolean}
     * @memberof OWQuestResponse
     */
    onAllSupportedGames?: boolean;
    /**
     * 
     * @type {OWRewardMode}
     * @memberof OWQuestResponse
     */
    mode?: OWRewardMode;
    /**
     * Ref to the challenge of this quest (only for challenge quests).
     * @type {string}
     * @memberof OWQuestResponse
     */
    challenge?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OWQuestResponse
     */
    isSponsored?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OWQuestResponse
     */
    sponsorName?: string;
    /**
     * 
     * @type {string}
     * @memberof OWQuestResponse
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof OWQuestResponse
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof OWQuestResponse
     */
    externalUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof OWQuestResponse
     */
    rewardImage?: string;
    /**
     * 
     * @type {number}
     * @memberof OWQuestResponse
     */
    startAt?: number;
    /**
     * 
     * @type {number}
     * @memberof OWQuestResponse
     */
    endAt?: number;
    /**
     * 
     * @type {Array<RewardConfigResponse>}
     * @memberof OWQuestResponse
     */
    rewardConfigs?: Array<RewardConfigResponse>;
}

export function OWQuestResponseFromJSON(json: any): OWQuestResponse {
    return OWQuestResponseFromJSONTyped(json, false);
}

export function OWQuestResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWQuestResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'game': !exists(json, 'game') ? undefined : json['game'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'isActive': json['isActive'],
        'showQuestCompleteNotification': !exists(json, 'showQuestCompleteNotification') ? undefined : json['showQuestCompleteNotification'],
        'questCompleteNotificationMessage': !exists(json, 'questCompleteNotificationMessage') ? undefined : json['questCompleteNotificationMessage'],
        'rewardMax': !exists(json, 'rewardMax') ? undefined : json['rewardMax'],
        'rewardMaxType': !exists(json, 'rewardMaxType') ? undefined : OWRewardMaxTypeFromJSON(json['rewardMaxType']),
        'rewardCategory': OWLogCategoryFromJSON(json['rewardCategory']),
        'eventType': json['eventType'],
        'target': json['target'],
        'questReset': !exists(json, 'questReset') ? undefined : QuestResetFromJSON(json['questReset']),
        'milestones': !exists(json, 'milestones') ? undefined : ((json['milestones'] as Array<any>).map(MilestoneResponseFromJSON)),
        'onAllSupportedGames': !exists(json, 'onAllSupportedGames') ? undefined : json['onAllSupportedGames'],
        'mode': !exists(json, 'mode') ? undefined : OWRewardModeFromJSON(json['mode']),
        'challenge': !exists(json, 'challenge') ? undefined : json['challenge'],
        'isSponsored': !exists(json, 'isSponsored') ? undefined : json['isSponsored'],
        'sponsorName': !exists(json, 'sponsorName') ? undefined : json['sponsorName'],
        'logo': !exists(json, 'logo') ? undefined : json['logo'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'externalUrl': !exists(json, 'externalUrl') ? undefined : json['externalUrl'],
        'rewardImage': !exists(json, 'rewardImage') ? undefined : json['rewardImage'],
        'startAt': !exists(json, 'startAt') ? undefined : json['startAt'],
        'endAt': !exists(json, 'endAt') ? undefined : json['endAt'],
        'rewardConfigs': !exists(json, 'rewardConfigs') ? undefined : ((json['rewardConfigs'] as Array<any>).map(RewardConfigResponseFromJSON)),
    };
}

export function OWQuestResponseToJSON(value?: OWQuestResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'game': value.game,
        'name': value.name,
        'description': value.description,
        'isActive': value.isActive,
        'showQuestCompleteNotification': value.showQuestCompleteNotification,
        'questCompleteNotificationMessage': value.questCompleteNotificationMessage,
        'rewardMax': value.rewardMax,
        'rewardMaxType': OWRewardMaxTypeToJSON(value.rewardMaxType),
        'rewardCategory': OWLogCategoryToJSON(value.rewardCategory),
        'eventType': value.eventType,
        'target': value.target,
        'questReset': QuestResetToJSON(value.questReset),
        'milestones': value.milestones === undefined ? undefined : ((value.milestones as Array<any>).map(MilestoneResponseToJSON)),
        'onAllSupportedGames': value.onAllSupportedGames,
        'mode': OWRewardModeToJSON(value.mode),
        'challenge': value.challenge,
        'isSponsored': value.isSponsored,
        'sponsorName': value.sponsorName,
        'logo': value.logo,
        'color': value.color,
        'externalUrl': value.externalUrl,
        'rewardImage': value.rewardImage,
        'startAt': value.startAt,
        'endAt': value.endAt,
        'rewardConfigs': value.rewardConfigs === undefined ? undefined : ((value.rewardConfigs as Array<any>).map(RewardConfigResponseToJSON)),
    };
}


